type PKey = "history";

export const getLocalStorage = (key: PKey, defaultValue: any) => {
  if (key in localStorage && localStorage[key] !== "null") {
    return JSON.parse(localStorage[key]);
  } else {
    return defaultValue;
  }
};
export const setLocalStorage = (key: PKey, value: any) => {
  localStorage[key] = JSON.stringify(value);
};
export const doCopy = (aa: string) => {
  if (navigator.clipboard) {
    navigator.clipboard.writeText(aa);
  }
};
